module.exports = __webpack_public_path__ + "img/dsci0051.848ddc3c.jpg";